import { HostBinding, Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-bolsas-financiamento',
  templateUrl: './bolsas-financiamento.component.html',
  styleUrls: ['./bolsas-financiamento.component.scss'],
  animations: [routerTransition],
})
export class BolsasFinanciamentoComponent implements OnDestroy {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  routerSubscription;
  
  environment = environment;

  constructor(
    private router: Router,
  ) {
    this.routerSubscription = this.router.events.subscribe(navigationEvent => {
      if (navigationEvent instanceof NavigationEnd) {
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
          const element = document.getElementById(tree.fragment);
          if (element) {
            const child = element.firstElementChild;
            if (!child.classList.contains('active') && child.children[0]) {
              child.querySelector('header').click();
            }
            // espera pelo toogle
            setTimeout(() => {
              element.scrollIntoView();
            }, 150);
          }
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
